var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cz8frdsrva",
    d: "M48.648 70H21.352c-.544 0-1.066-.216-1.45-.6L.601 50.097C.216 49.714 0 49.192 0 48.648V21.352c0-.544.216-1.066.6-1.45L19.903.6c.384-.385.906-.601 1.45-.601h27.296c.544 0 1.066.216 1.45.6L69.4 19.903c.385.384.601.906.601 1.45v27.296c0 .544-.216 1.065-.6 1.45L50.097 69.399c-.384.385-.906.601-1.45.601z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3xbfn7m4cd",
    d: "M52.572 39.072c0 .83-.67 1.5-1.5 1.5h-10.5v10.5c0 .83-.67 1.5-1.5 1.5h-9c-.829 0-1.5-.67-1.5-1.5v-10.5h-10.5c-.829 0-1.5-.67-1.5-1.5v-9c0-.829.671-1.5 1.5-1.5h10.5v-10.5c0-.829.671-1.5 1.5-1.5h9c.83 0 1.5.671 1.5 1.5v10.5h10.5c.83 0 1.5.671 1.5 1.5v9z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cp98m4k5pc",
    width: "530.6%",
    height: "530.6%",
    x: "-215.3%",
    y: "-209.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 25.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685 -273) translate(570 233) translate(115 40)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "52761slskb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cz8frdsrva"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F64000",
    fillRule: "nonzero",
    xlinkHref: "#cz8frdsrva"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#52761slskb)",
    transform: "rotate(45 34.572 34.572)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cp98m4k5pc)",
    xlinkHref: "#3xbfn7m4cd"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#3xbfn7m4cd"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.dae17d191310a94e13e1a86652c1e6dc.svg";
export { ForwardRef as ReactComponent };